import React from 'react';
import { Alert } from '@mui/material';

const ShowAlertTextBox = ({
  isOpen,
  type,
  text,
}: {
  isOpen: boolean;
  type: 'warning' | 'info' | 'success' | 'error';
  text: string | JSX.Element;
}) => {
  return isOpen ? <Alert severity={type}>{text}</Alert> : <></>;
};

export default ShowAlertTextBox;
